/**
 * Exports.
 * Exporting a split type is useful when used in multiple places throughout the app
 */

export const UPGRADE_PROMPTS = 'upgrade_prompts'



// WEBPACK FOOTER //
// ./lib/feature/feature-types.js